import { useState } from 'react';

import { FormGroup } from '@/components/FormGroup';

import Details from './Details';

const ProductDetailsBlock = () => {
  const [reviewMode, setReviewMode] = useState(true);

  return (
    <FormGroup collapsable={false} showValidationState={false} reviewMode={reviewMode} allowEdit={false}>
      <Details onEdit={() => setReviewMode(false)} />
    </FormGroup>
  );
};

export default ProductDetailsBlock;
